import api from './api';

const informeListService = {
  async getAll() {
    const response = await api.get('/api/informes/?estado=4');
    const data = response.data || [];
    return informeListService._normalize(data);
  },

  async getByTipo(tipo) {
    const response = await api.get('/api/informes/?estado=4');
    const data = response.data || [];
    const normalized = informeListService._normalize(data);
    if (!tipo) return normalized;
    return normalized.filter((i) => i.tipo === tipo);
  },

  async getByEvaluado(id_entidad) {
    const response = await api.get(`/api/informes/?evaluado=${id_entidad}&estado=4`);
    const data = response.data || [];
    return informeListService._normalize(data);
  },

  // _normalize(data) {
  //   return data.map((informe) => ({
  //     id: informe.id,
  //     tipo: (() => {
  //       const nombre = (informe.evento_nombre || '').toLowerCase();
  //       const tituloItem = (informe.Items?.[0]?.titulo || '').toLowerCase();
  //       if (nombre.includes('amarre') || tituloItem.includes('amarre')) return 'amarre';
  //       return 'trianual';
  //     })(),
  //     fecha: informe.fecha_programada || informe.alta,
  //     id_evaluacion: informe.id_evaluacion,
  //     id_evento: informe.id_evento,
  //     evaluadosSummary: (informe.evaluado_nombre || '').trim() || '-',
  //     legajosSummary: informe.id_evaluado ? String(informe.id_evaluado) : '-',
  //     _raw: informe
  //   }));
  // }

  _normalize(data) {
    // const rows = data.map(() =>{})
    const rows = data.map((informe) => ({
      id: informe.id,
      tipo: (() => {
        const nombre = (informe.evento_nombre || '').toLowerCase();
        const tituloItem = (informe.Items?.[0]?.titulo || '').toLowerCase();
        if (nombre.includes('toolbox') || tituloItem.includes('toolbox')) return 'toolbox';
        if (nombre.includes('amarre') || tituloItem.includes('amarre')) return 'amarre';
        return 'trianual';
      })(),
      fecha: informe.fecha_programada || informe.alta,
      id_evaluacion: informe.id_evaluacion,
      id_evento: informe.id_evento,
      evaluadosSummary: (informe.evaluado_nombre || '').trim() || '-',
      legajosSummary: (() => {
        try {
          const evaluado = informe.Evaluado;
          if (!evaluado) return informe.id_evaluado ? String(informe.id_evaluado) : '-';
          const metadata = typeof evaluado.metadata === 'string'
            ? JSON.parse(evaluado.metadata)
            : evaluado.metadata || {};
          return metadata.legajo || (informe.id_evaluado ? String(informe.id_evaluado) : '-');
        } catch {
          return informe.id_evaluado ? String(informe.id_evaluado) : '-';
        }
      })(),
      _raw: informe,
    }));

    return informeListService._groupByEvento(rows);
  },

  _groupByEvento(items) {
    const result = [];
    const byEvento = new Map();

    for (const item of items) {
      if ((item.tipo === 'amarre' || item.tipo === 'toolbox') && item.id_evento) {
        if (byEvento.has(item.id_evento)) {
          const group = byEvento.get(item.id_evento);
          if (item.evaluadosSummary && item.evaluadosSummary !== '-') {
            group.evaluadosSummary = group.evaluadosSummary !== '-'
              ? `${group.evaluadosSummary}, ${item.evaluadosSummary}`
              : item.evaluadosSummary;
          }
          if (item.legajosSummary && item.legajosSummary !== '-') {
            group.legajosSummary = group.legajosSummary !== '-'
              ? `${group.legajosSummary}, ${item.legajosSummary}`
              : item.legajosSummary;
          }
        } else {
          const grouped = { ...item, id: item.id_evento };
          byEvento.set(item.id_evento, grouped);
          result.push(grouped);
        }
      } else {
        result.push(item);
      }
    }

    return result;
  },
};

export default informeListService;
